import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { siteConfig } from "../Datas/productData";
import "../css/paysuccess.css";

const createReference = () => {
  const brandWords = (siteConfig.brandName || "Order").split(/\s+/);
  const prefix = (
    brandWords.length > 1
      ? brandWords.map((word) => word.charAt(0)).join("")
      : brandWords[0].slice(0, 2)
  )
    .slice(0, 3)
    .toUpperCase();
  const date = new Date().toISOString().slice(2, 10).replace(/-/g, "");
  const suffix = Math.floor(1000 + Math.random() * 9000);
  return `${prefix}-${date}-${suffix}`;
};

const PaySuccess = () => {
  const location = useLocation();
  const [fallbackReference] = useState(createReference);
  const reference =
    location.state?.orderReference ||
    location.state?.orderNumber ||
    location.state?.reference ||
    fallbackReference;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="success-pay" aria-labelledby="success-pay-title">
      <section className="success-pay__content">
        <div className="success-pay__mark" aria-hidden="true">
          <FontAwesomeIcon icon={faCheck} />
        </div>

        <p className="success-pay__eyebrow">Order confirmed</p>
        <h1 id="success-pay-title">Thank you for your order.</h1>
        <p className="success-pay__message">
          Your payment has been authorized and your order is now being prepared.
          A confirmation email with delivery details will follow shortly.
        </p>

        <dl className="success-pay__summary">
          <div>
            <dt>Order reference</dt>
            <dd>{reference}</dd>
          </div>
          <div>
            <dt>Status</dt>
            <dd>Confirmed</dd>
          </div>
        </dl>

        <div className="success-pay__actions">
          <Link to="/shop" onClick={toTop}>
            Continue shopping
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact Client Services
          </Link>
        </div>

        <p className="success-pay__footnote">
          Keep your order reference for any questions about this purchase from
          {` ${siteConfig.brandName}`}.
        </p>
      </section>
    </main>
  );
};

export default PaySuccess;
